/* istanbul ignore file */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pageView } from '@cmctechnology/webinvest-analytics-compat';
import { useSelector } from 'react-redux';
import { IStore } from '../Store/Store';

export const useAnalyticsPageView = () => {
  const location = useLocation();
  const analyticsEnabled = useSelector((store: IStore) => store.local.analyticsEnabled);

  useEffect(() => {
    if (analyticsEnabled) {
      pageView({
        Url: window.location.toString(),
        Path: location.pathname,
        Title: document.title,
        Host: window.location.hostname
      });
    }
  }, [location.pathname]);
};
